import { IDmMucHocPhiTheoCTDTCopyKyThuRequest } from "../../../model/request/category/dmMucHocPhiTheoCTDTCopyKyThuRequest";
import { IDmMucHocPhiTheoCTDTViewModelRequest } from "../../../model/request/category/dmMucHocPhiTheoCTDTViewModelRequest";
import {
  IMucHocPhiTheoCTDT,
  IMucHocPhiTheoCTDTCTDT,
  IMucHocPhiTheoCTDTMon,
} from "../../../model/respone/category/IDmMucHocPhiTheoCTDT";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmMucHocPhiTheoCTDTActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_CTDTS_START: {} as IDmMucHocPhiTheoCTDTViewModelRequest,
  LOAD_CTDTS_SUCCESS: {} as IMucHocPhiTheoCTDTCTDT[],
  LOAD_CTDTS_ERRR: "",

  LOAD_START: {} as IDmMucHocPhiTheoCTDTViewModelRequest,
  LOAD_SUCCESS: {} as IMucHocPhiTheoCTDTMon[],
  LOAD_ERRR: "",

  SAVE_START: {} as IMucHocPhiTheoCTDT[],
  SAVE_SUCCESS: {} as IMucHocPhiTheoCTDT[],
  SAVE_ERROR: "",

  CHANGE_REQUEST: {} as IDmMucHocPhiTheoCTDTViewModelRequest,

  LOCK_START: {} as IDmMucHocPhiTheoCTDTViewModelRequest,
  LOCK_SUCCESS: {} as IMucHocPhiTheoCTDT[],
  LOCK_ERRR: "",

  UNLOCK_START: {} as IDmMucHocPhiTheoCTDTViewModelRequest,
  UNLOCK_SUCCESS: {} as IMucHocPhiTheoCTDT[],
  UNLOCK_ERRR: "",

  SHOWHIDE_COPY_MODAL: {} as boolean,
  COPY_START: {} as IDmMucHocPhiTheoCTDTCopyKyThuRequest,
  COPY_SUCCESS: 0 as number,
  COPY_ERROR: "",
  COPY_CHANGE_REQUEST: {} as any,

  CHANGE_MODE_EDIT: {} as number,
};

export const eDmMucHocPhiTheoCTDTActionIds = generateActionTypeIds(
  eDmMucHocPhiTheoCTDTActionsObj,
  "MUC_HOC_PHI_THEO_CTDT",
);

export type IDmMucHocPhiTheoCTDTActionTypes = IGenericActionType<
  typeof eDmMucHocPhiTheoCTDTActionsObj,
  "MUC_HOC_PHI_THEO_CTDT"
>;
